import { BReactComponent } from 'blocks-cloud/b-react-component';

import { OldTariffsDialog } from './ui/OldTariffsDialog';

let OldTariffsDialogToolkit;
let el;

export const renderOldTariffsDialog = ({ onSuccess, onClose, onProductSelect }) => {
    if (OldTariffsDialogToolkit) {
        OldTariffsDialogToolkit.destroy();
        onClose();
    }
    OldTariffsDialogToolkit = new BReactComponent({
        ReactComponent: OldTariffsDialog,
        renderMode: 'replace',
    });

    if (!el) {
        el = document.createElement('div');
    }

    document.body.appendChild(el);

    const onDialogClose = () => {
        if (OldTariffsDialogToolkit) {
            OldTariffsDialogToolkit.destroy();
            OldTariffsDialogToolkit = null;
        }
        onClose();
    };

    const onProductSelectCallback = (productId) => {
        onProductSelect(productId);
        onDialogClose();
    };

    OldTariffsDialogToolkit.renderTo(el, {
        props: {
            onSuccess,
            onClose: onDialogClose,
            onProductSelect: onProductSelectCallback,
        },
    });
};

export default {
    renderOldTariffsDialog,
};
